import React, { useRef, useState, useEffect } from 'react';
import classes from './Register.module.css';
import fl_logo from '../../assets/fl_logo.png';
import { EmailOutlined } from '@material-ui/icons';
import CustomTextField from '../../ui/CustomTextField';
import CustomButton from '../../ui/CustomButton';
import CustomSpinner from '../../ui/CustomSpinner';
import useV3Axios from '../../hooks/useV3Axios';
import { useHistory } from 'react-router-dom';
import { REGISTER_VERIFY_PATH, LOGIN_PATH } from '../../utils/paths';

const Register = () => {
    const emailRef = useRef(null);
    const [error, setError] = useState(null);
    const history = useHistory();

    const { isLoading, error: axiosError, data, sendRequest } = useV3Axios();

    useEffect(() => {
        if (data) {
            history.push(REGISTER_VERIFY_PATH, { email: emailRef.current.value.trim() });
        }
    }, [data, history]);

    useEffect(() => {
        if (axiosError) setError(axiosError);
    }, [axiosError]);

    const handleSubmit = (event) => {
        event.preventDefault();
        setError(null);
        sendRequest('/register/send-otp', { email: emailRef.current.value.trim() });
    };

    return (
        <div className={classes.Login}>
            <div className={classes.Card}>
                <img className={classes.Logo} src={fl_logo} alt="logo" />
                <p className={classes.Title}>FetalLite Dashboard</p>
                <form className={classes.Form} onSubmit={handleSubmit}>
                    <h3 style={{ textAlign: 'left', margin: '0 0 16px 0', color: '#333' }}>Create an account</h3>
                    <CustomTextField margin="10px auto" reference={emailRef} required id='email' label='Email address' type='email'>
                        <EmailOutlined />
                    </CustomTextField>
                    {error && <p className={classes.Error}>{error}</p>}
                    <div className={classes.Container}>
                        {isLoading ? <CustomSpinner /> : <CustomButton type='submit' size='large'>SEND OTP</CustomButton>}
                    </div>
                    <hr className={classes.Divider} />
                    <p style={{ textAlign: 'center', fontSize: '14px', color: '#555' }}>
                        Already have an account?{' '}
                        <span className={classes.Link} onClick={() => history.push(LOGIN_PATH)}>Sign in</span>
                    </p>
                </form>
            </div>
        </div>
    );
};

export default Register;
